// This shortening isn't perfect, the short version of someone's name isn't
// always just the characters before the first space or '@', but given just a
// full name string or email it's hard to do better without adding configuration
// for this in the app.
export const shortenUsername = (username: string): string => {
  const shortName = username.split(" ")[0].split("@")[0];
  return shortName.charAt(0).toUpperCase() + shortName.slice(1);
};
